/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../../locales/en-US/descriptors';
import {
  EnergyUsagesDetailExpandMeterField,
  PreferredUnit
} from '../../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import {
  IEmaasEnergyUsageComponentDataArea,
  IEnergyMeter
} from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import './EnergyScopeSavingsByMeterDetail.scss';
import { convertDataForAreaWiseEnergyUsagesSavingsMeter } from '../../../../shared/Utils/EnergyUsagesFloorViewDetailsUtils';
import EmaasDetailBreakdownByFloor from '../../AllUtilitiesDetails/EmaasDetailBreakdownByFloor';
import { IBreakdownByFloor } from '../../AllUtilitiesDetails/IEnergyUsagesBreakdownProps';
import { ApiContext } from '../../../../../context/ApiContext';
import { ConversionType } from '../../../../../main';
import { EnergyUsageField } from '../../../../shared/Enums';
import EmaasDetailBreakdownByFloorInfiniteScroll from '../../AllUtilitiesDetails/EmaasDetailBreakdownByFloorInfiniteScroll';

export interface IEnergyBreakDownByArea {
  data: IEmaasEnergyUsageComponentDataArea;
  UtilityBillType: string;
}

export const energyScopeSavingsByAreasDetailComponent = (
  props: IEnergyBreakDownByArea
) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;

  let fromUnit;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit =
    props.data.sourceType && props.data.sourceType.toLowerCase() === 'water'
      ? PreferredUnit.Water
      : userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : props.data.sourceType === ConversionType.GAS
      ? apiContext.toggleEnableKwhGas
        ? PreferredUnit.Electricity
        : PreferredUnit.Gas
      : (PreferredUnit.Electricity as any);
  const {
    data: {
      energyMeasurementUnit,
      breakdownByMeter,
      areaWiseAggregations,
      sourceType
    }
  } = props;

  const {
    values,
    displayUnit
  } = convertDataForAreaWiseEnergyUsagesSavingsMeter(
    breakdownByMeter as IEnergyMeter[],
    fromUnit, //energyMeasurementUnit,
    areaWiseAggregations,
    energyMeasurementUnit,
    sourceType,
    apiContext.showChangeWhenData
  );

  const columnDetails: IDataTableColumn[] = [
    {
      className: 'datatable-column-meter',
      field: EnergyUsagesDetailExpandMeterField.meter,
      header: t(d.METER),
      sortable: true,
      initialWidth: '30%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: EnergyUsagesDetailExpandMeterField.actualConsumption,
      header: t(d.actualCost),
      sortable: true,
      initialWidth: '40%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: EnergyUsagesDetailExpandMeterField.baselineConsumption,
      header:
        props.data.subscriptionType === EnergyUsageField.BASICSUBS
          ? t(d.PREVSPER)
          : props.data.sourceType &&
            props.data.sourceType.toLowerCase() === 'water'
          ? t(d.PREVIOUSPERIOD)
          : t(d.baselineCost),
      sortable: true,
      initialWidth: '15%'
    },
    {
      className: 'datatable-column-change',
      field: EnergyUsagesDetailExpandMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '15%'
    },
    {
      className: 'datatable-column-details',
      field: EnergyUsagesDetailExpandMeterField.eqdetails,
      header: '',
      sortable: false,
      initialWidth: '5%'
    }
  ];

  const breakDownByMeterProps = ({
    meterData: values,
    utilityMeasurementUnit: displayUnit,
    columnDetails,
    energyMeasurementUnit: energyMeasurementUnit,
    sourceType: sourceType
  } as unknown) as IBreakdownByFloor;

  const context = useContext(ApiContext);

  // useEffect(() => {
  //   if (
  //     context.enableViewDetailsMeterTrend &&
  //     context.onClickViewDetailsMeterTrend
  //   ) {
  //     breakDownByMeterProps.columnDetails.push({
  //       className: 'datatable-column-details',
  //       field: EnergyUsagesDetailExpandMeterField.eqdetails,
  //       header: '',
  //       sortable: false,
  //       initialWidth: '5%'

  //     });
  //   }
  // }, [
  //   context,
  //   context.enableViewDetailsMeterTrend,
  //   context.onClickViewDetailsMeterTrend
  // ]);

  return (
    <div className="emaas-Metersaving-details-head">
      {apiContext.toggleSeparateApi ? (
        <EmaasDetailBreakdownByFloorInfiniteScroll {...breakDownByMeterProps} />
      ) : (
        <EmaasDetailBreakdownByFloor {...breakDownByMeterProps} />
      )}
    </div>
  );
};
export default memo(energyScopeSavingsByAreasDetailComponent);
